<div class="single-select-wrapper relative" [class]="styleClass" [class.dropdown-open]="isOpen">
  <div 
    class="single-select-trigger w-full min-w-[200px] bg-white cursor-pointer transition-all duration-200 relative"
    [class.opacity-50]="disabled"
    [class.cursor-not-allowed]="disabled"
    (click)="toggleDropdown()"
  >
    <div class="flex items-center justify-between min-w-0">
      <div class="flex-1 flex flex-wrap gap-2 min-h-[24px] items-center min-w-0">
        <!-- Placeholder when no item selected -->
        <span 
          *ngIf="!selectedValue" 
          class="text-gray-500 text-sm"
        >
          {{ placeholder }}
        </span>
        
        <!-- Show chip when item is selected -->
        <span
          *ngIf="selectedValue"
          class="inline-flex max-w-full items-center gap-1.5 px-2.5 py-1.5 bg-[#00d084] text-white text-xs font-medium rounded-md shadow-sm hover:bg-[#00b875] transition-colors"
        >
          <span class="min-w-0 break-words text-left">{{ getDisplayValue() }}</span>
          <svg
            *ngIf="showClear && !disabled"
            class="w-3 h-3 cursor-pointer hover:text-gray-200 transition-colors"
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
            (click)="clearSelection($event); $event.stopPropagation()"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </span>
      </div>
      
      <div class="flex items-center gap-2 flex-shrink-0 ml-2">
        <!-- Caret icon -->
        <svg 
          class="w-5 h-5 text-gray-500 transition-transform duration-200"
          [class.rotate-180]="isOpen"
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
        </svg>
      </div>
    </div>
  </div>

  <!-- Dropdown Panel -->
  <div
    *ngIf="isOpen && (filterable || optionsLoading || (options && options.length > 0) || loadingMore)"
    class="dropdown-panel absolute w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-xl max-h-60 overflow-auto flex flex-col"
    style="top: 100%; left: 0; min-width: 200px;"
    (click)="$event.stopPropagation()"
    (scroll)="onDropdownScroll($event)"
  >
    <div
      *ngIf="filterable"
      class="sticky top-0 z-10 flex-shrink-0 bg-white px-3 py-2 border-b border-gray-100"
      (click)="$event.stopPropagation()"
    >
      <div class="relative">
        <input
          type="text"
          class="w-full rounded-md border border-gray-300 py-1.5 pl-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:border-[#00d084] focus:outline-none focus:ring-1 focus:ring-[#00d084]"
          [class.pr-8]="filterText"
          [class.pr-2.5]="!filterText"
          [placeholder]="filterPlaceholder"
          [value]="filterText"
          (input)="onFilterInput($event)"
          (keydown)="onFilterKeydown($event)"
          autocomplete="off"
        />
        <button
          *ngIf="filterText"
          type="button"
          class="absolute right-1 top-1/2 -translate-y-1/2 flex h-7 w-7 items-center justify-center rounded text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-[#00d084]/40"
          (click)="clearFilterSearch($event)"
          aria-label="Clear search"
        >
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <div *ngIf="optionsLoading" class="flex items-center justify-center gap-2 px-3 py-3 text-sm text-gray-400">
      <svg class="animate-spin w-4 h-4 text-[#00d084]" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
      </svg>
      <span>Searching...</span>
    </div>

    <!-- Options List -->
    <div class="py-1 flex-1 min-h-0" *ngIf="!optionsLoading">
      <div
        *ngFor="let option of options; trackBy: trackByOption"
        [class]="getOptionClasses(option)"
        (click)="selectOption(option)"
      >
        <!-- Checkbox -->
        <div class="flex items-center mr-3 flex-shrink-0">
          <input
            type="checkbox"
            [checked]="isSelected(option)"
            class="w-4 h-4 checkbox-custom border-gray-300 rounded focus:ring-2 cursor-pointer"
            (click)="$event.stopPropagation(); selectOption(option)"
            readonly
          />
        </div>
        
        <!-- Option Label -->
        <span 
          class="text-sm text-gray-700 flex-1"
          [class.text-[#00d084]]="isSelected(option)"
          [class.font-medium]="isSelected(option)"
        >
          {{ getOptionLabel(option) }}
        </span>
      </div>
      
      <div *ngIf="!optionsLoading && options.length === 0" class="px-3 py-2 text-sm text-gray-500 text-center">
        No options available
      </div>
    </div>

    <!-- Loading more sentinel -->
    <div *ngIf="loadingMore" class="flex items-center justify-center gap-2 px-3 py-2 text-sm text-gray-400 border-t border-gray-100">
      <svg class="animate-spin w-4 h-4 text-[#00d084]" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
      </svg>
      <span>Loading more...</span>
    </div>
  </div>
</div>
